import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import StyledButton from "../atoms/StyledButton";
import PropTypes from "prop-types";
import useCnaeContext from "../../contexts/CnaeContext";
import CnaeTitle from "../atoms/CnaeTitle";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  button: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  texts: {
    maxWidth: "75%",
    [theme.breakpoints.down("md")]: {
      maxWidth: "65%",
    },
    "& .MuiTypography-body1": {
      color: theme.palette.gray.darkGray,
    },
  },
}));

export default function HeaderDetailsDesktop() {
  const classes = useStyles();

  const { currentCnae } = useCnaeContext();

  return (
    <Box className={classes.header}>
      <Box className={classes.texts}>
        <CnaeTitle
          cnae={currentCnae.subclasse}
          status={currentCnae.simplesNacional}
        />
        <Typography variant={"body1"} component={"h1"}>
          {currentCnae.descricao}
        </Typography>
      </Box>
      <Box className={classes.button}>
        <StyledButton
          id="abrir-empresa-pesquisa-desktop"
          style={{ borderColor: "#31AEFF", color: "#31AEFF" }}
          type={"dashed"}
          text={"Abrir Empresa Grátis"}
          onClick={() => {
            window.location.href = `${process.env.GATSBY_CONUBE_URL}/abrir-empresa`;
          }}
        />
      </Box>
    </Box>
  );
}

HeaderDetailsDesktop.propTypes = {
  currentCnae: PropTypes.func.isRequired,
};
